export const monthlyVendorSummary = (expenses = []) => {
  const groups = new Map();
  expenses.forEach((expense) => {
    const month = /^\d{4}-(0[1-9]|1[0-2])-\d{2}$/.test(expense.date || '') ? expense.date.slice(0, 7) : '';
    const vendor = String(expense.vendor || '').trim() || 'Non renseigné';
    const key = JSON.stringify([month, vendor.toLocaleLowerCase('fr-CA')]);
    const row = groups.get(key) || { key, month, vendor, count: 0, totalCad: 0 };
    row.count += 1;
    row.totalCad += Number.isFinite(Number(expense.amountCad)) ? Number(expense.amountCad) : 0;
    groups.set(key, row);
  });
  return [...groups.values()].sort((a, b) => b.month.localeCompare(a.month) || a.vendor.localeCompare(b.vendor, 'fr-CA'));
};
export const formatExpenseMonth = (month) => month
  ? new Intl.DateTimeFormat('fr-CA', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${month}-01T12:00:00Z`))
  : 'Date non renseignée';
